var React = require('react');

function UpgradeIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19 5H13V3H21V11H19V5Z","fill":"#0088BF","key":0}),React.createElement("path",{"d":"M19.125 3.29289L20.5392 4.70711L12.7072 12.5391L11.293 11.1249L19.125 3.29289Z","fill":"#0088BF","key":1}),React.createElement("path",{"d":"M17 13.1021H19V18C19 19.6569 17.6569 21 16 21H6C4.34315 21 3 19.6569 3 18V8C3 6.34315 4.34315 5 6 5H11.021V7H6C5.44772 7 5 7.44772 5 8V18C5 18.5523 5.44772 19 6 19H16C16.5523 19 17 18.5523 17 18V13.1021Z","fill":"#0088BF","key":2})]);
}

UpgradeIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = UpgradeIcon;

UpgradeIcon.default = UpgradeIcon;
